import axios from "axios";
import { API_BASE } from "../../config/env";
import { useEffect } from "react";
export const FETCH_PAYMENT_FULFILLED = "FETCH_PAYMENT_FULFILLED";
export const FETCH_PAYMENT_REJECTED = "FETCH_PAYMENT_REJECTED";
export const FETCH_PAYMENT_PENDING = "FETCH_PAYMENT_PENDING";
export const RESET = "RESET"

export function payment(applicationId, careProviderId, cardHolder, cardNumber, ccv, expirationMonth, expirationYear, voucherCode) {
    const token = localStorage.getItem("accessToken")
    const data = {
        "Application": {
            "applicationId": applicationId,
            "careProviderId": careProviderId
        },
        "cardInfoRequest": {
            "CardHolder": cardHolder,
            "CardNumber": cardNumber,
            "Ccv": ccv,
            "ExpirationMonth": expirationMonth,
            "ExpirationYear": expirationYear
        },
        "VoucherCode": voucherCode,
    }
    const jsonData = JSON.stringify(data)
    



    return (dispatch) => {
        dispatch({
            type: "FETCH_PAYMENT",
            payload: axios({
                method: "post",
                url: `${API_BASE}/api/v2/payment`,
                headers: {
                    "Authorization": "Bearer " + token,
                    "Accept-Language": "tr-tr",
                    "Client-Id": localStorage.getItem("One-Id"),
                    "One-Id": localStorage.getItem("Client-Id"),
                    "Content-Type": "application/json",
                    "ngrok-skip-browser-warning" : "69920"
                },
                data: jsonData,
            }).then((result) => result.data),
        });
    };
}

export function resetPayment() {
    return (dispatch) => {
        dispatch({
            type: "RESET",
        });
    };
}


